export default __webpack_public_path__ + "static/media/liikennejarjestelyt_hero.c786652f.jpeg";